module.exports = __webpack_public_path__ + "static/media/Bot_Breaker_Full_Size.733ede95.jpg";